import { useEffect, useState } from "react";

export type Breakpoint = "mobile" | "tablet" | "desktop";

const MOBILE_MAX = "(max-width: 767.98px)";
const TABLET_RANGE = "(min-width: 768px) and (max-width: 991.98px)";

const read = (): Breakpoint => {
  if (typeof window === "undefined") return "desktop";
  if (window.matchMedia(MOBILE_MAX).matches) return "mobile";
  if (window.matchMedia(TABLET_RANGE).matches) return "tablet";
  return "desktop";
};

export default function useBreakpoint(): Breakpoint {
  const [bp, setBp] = useState<Breakpoint>(read);

  useEffect(() => {
    const mobile = window.matchMedia(MOBILE_MAX);
    const tablet = window.matchMedia(TABLET_RANGE);
    const update = () => setBp(read());
    mobile.addEventListener("change", update);
    tablet.addEventListener("change", update);
    return () => {
      mobile.removeEventListener("change", update);
      tablet.removeEventListener("change", update);
    };
  }, []);

  return bp;
}
